import React from 'react';
import { Doc } from '@/convex/_generated/dataModel';

export interface GlobalSearchTask extends Doc<'normalTasks'> {
  contextName: string;
  contextColor?: string;
  projectName?: string;
  categoryName?: string;
}

export interface GlobalSearchContext {
  isOpen: boolean;
  search: string;
  setSearch: (search: string) => void;
  openSearch: () => void;
  closeSearch: () => void;
  searchResults: {
    activeTasks: GlobalSearchTask[];
    completedTasks: GlobalSearchTask[];
    projects: (Doc<'projects'> & { contextName: string })[];
    categories: (Doc<'categories'> & { contextName: string })[];
    contexts: Doc<'contexts'>[];
  };
}

export const SearchContext = React.createContext<GlobalSearchContext | null>(null);